import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { mediaTablet, mediaPhone } from '../../styles/breakpoints';
import { PHONE_MARGIN } from '../../styles/pageLayout';

import Mauer1Img from './Mauer1.png';
import Mauer1Img2x from './Mauer1@2x.png';
import Mauer2Img from './Mauer2.png';
import Mauer2Img2x from './Mauer2@2x.png';

import RhombusDesktopImg from './rhombus-desktop.svg';
import RhombusTabletImg from './rhombus-tablet.svg';
import RhombusPhoneImg from './rhombus-phone.svg';

const Rhombus = styled.section`
  margin-top: 80px;

  position: relative;

  background-size: 100% 92%;
  background-repeat: no-repeat;

  background-image: url(${RhombusDesktopImg});

  ${mediaTablet} {
    margin-top: 50px;
    background-size: 100% 75%;
    background-image: url(${RhombusTabletImg});
  }

  ${mediaPhone} {
    margin-top: 60px;
    background-size: 100% 95%;
    background-image: url(${RhombusPhoneImg});

    margin-left: -${PHONE_MARGIN}px;
    margin-right: -${PHONE_MARGIN}px;
    padding-left: ${PHONE_MARGIN}px;
    padding-right: ${PHONE_MARGIN}px;
  }

  @media (max-width: 576px) { background-size: 100% 90%; }
  @media (max-width: 475px) { background-size: 100% 87%; }
`;

const Mauer = (width, height, scaleTablet, img, img2x) => styled.div`
  position: absolute;

  width: ${width}px;
  height: ${height}px;

  ${mediaTablet} {
    width: ${Math.round(width * scaleTablet)}px;
    height: ${Math.round(height * scaleTablet)}px;
  }

  background-position: center;
  background-size: contain;
  background-image: url(${img});

  @media only screen and (-o-min-device-pixel-ratio: 1.25),
         only screen and (-webkit-min-device-pixel-ratio: 1.25),
         only screen and (min-device-pixel-ratio: 1.25)
  {
    background-image: url(${img2x});
  }
`;

const MauerEastside = styled(Mauer(617, 380, 0.73, Mauer1Img, Mauer1Img2x))`
  left: -260px;
  bottom: -65px;
  ${mediaTablet} {
    left: -167px;
    bottom: 17px;
  }
  ${mediaPhone} {
    left: -140px;
    bottom: 106px;
  }
`;

const MauerWestside = styled(Mauer(361, 415, 0.69, Mauer2Img, Mauer2Img2x))`
  right: -210px;
  bottom: -35px;
  ${mediaTablet} {
    right: -147px;
    bottom: 66px;
  }
  ${mediaPhone} {
    right: -60px;
    bottom: 144px;
  }
`;

const MauerBack = ({ children }) => (
  <Rhombus>
    <MauerEastside />
    { children }
    <MauerWestside />
  </Rhombus>
);

MauerBack.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MauerBack;



// WEBPACK FOOTER //
// ./src/components/PageHeader/MauerBack/MauerBack.js